<div class="p-3">
    <div class="grid">
        <div class="col">
            <p-button icon="pi pi-arrow-left" label="Back" styleClass="p-button-primary" class="flex justify-content-center" (onClick)="goToList()"></p-button>
        </div>
        <!-- <div *ngIf="currentLimsToken == null" class="col">
            <p-button icon="pi pi-user-plus" label="Login" styleClass="p-button-success" class="flex justify-content-center" (onClick)="this.limsLoginModal = true"></p-button>
        </div>
        <div *ngIf="currentLimsToken != null" class="col">
            <p-button icon="pi pi-user-minus" label="Logout" styleClass="p-button-error" class="flex justify-content-center" (onClick)="clearUserToken()"></p-button>
        </div> -->
    </div>
</div>

<div *ngFor="let plateGroup of worklistDetails" class="pb-3">
    <div class="grid formgrid pt-2">
        <div class="col-12 text-bold">
            {{getGroupTypeName(plateGroup[0])}}
        </div>
        <div class="col-12">
            <hr>
        </div>
        <div class="col-12">
            <p-table [value]="plateGroup">
                <ng-template pTemplate="body" let-plate>
                    <tr>
                        <td>
                            <div class="grid formgrid text-sm">
                                <div *ngIf="plate.isRelated" class="col-1 w-1rem p-0">
                                    <i class="pi pi-star text-yellow-500"></i>
                                </div>
                                <div class="col">
                                    <div class="grid formgrid">
                                        <div class="col">
                                            <div class="col-12 font-bold">
                                                {{plate.barcodeText}}
                                            </div>
                                            <div class="col-12">
                                                {{plate.priorityText}}
                                            </div>
                                            <div class="col-12 text-xs">
                                                {{plate.dueDateText}}
                                            </div>
                                        </div>

                                        <div *ngIf="plate.instrumentViewModels[0].instrumentDisplayName != ''" class="col">
                                            <div class="grid formgrid text-right">
                                                <div class="col-12">
                                                    {{plate.instrumentViewModels[0].instrumentDisplayName}}
                                                </div>
                                                <div class="col-12 text-xs">
                                                    {{plate.instrumentViewModels[0].dateStartedText}}
                                                </div>
                                                <div class="col-12 text-xs">
                                                    {{plate.instrumentViewModels[0].dateFinishedText}}
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="plate.instrumentViewModels[1].instrumentDisplayName != ''" class="col">
                                            <div class="grid formgrid text-right">
                                                <div class="col-12">
                                                    {{plate.instrumentViewModels[1].instrumentDisplayName}}
                                                </div>
                                                <div class="col-12 text-xs">
                                                    {{plate.instrumentViewModels[1].dateStartedText}}
                                                </div>
                                                <div class="col-12 text-xs">
                                                    {{plate.instrumentViewModels[1].dateFinishedText}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="plate.shouldShowImageButton" class="col-1" (click)="showImage(plate)">
                                    <i class="pi pi-image text-blue-500"></i>
                                </div>
                                <div *ngIf="plate.shouldShowChartButton" class="col-1" (click)="showChart(plate)">
                                    <i class="pi pi-chart-line text-green-500"></i>
                                </div>
                                <div *ngIf="plate.shouldShowRetestButton" class="col-1" (click)="showRetest(plate)">
                                    <i class="pi pi-replay text-red-500"></i>
                                </div>
                                
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>


<p-dialog header="Plate Image"  [(visible)]="imageModal" [breakpoints]="{ '960px': '95vw' }" [style]="{ width: '90vw' }" [draggable]="false" [resizable]="false">
    <div class="grid p-fluid flex flex-wrap">
        <div class="col-12 p-1">
            <img [src]="selectedPlate?.plateImageUrl" class="max-w-full">
        </div>
        <div class="col-12 p-1">
            <p-button label="Close" styleClass="p-button-secondary" class="flex justify-content-center" (onClick)="imageModal = false"></p-button>
        </div>
    </div>
</p-dialog>

<p-dialog header="Plate Graph"  [(visible)]="graphModal" [breakpoints]="{ '960px': '95vw' }" [style]="{ width: '90vw' }" [draggable]="false" [resizable]="false">
    <div class="grid p-fluid flex flex-wrap">
        <div class="col-12">
            <label for="probes">Probe</label>
            <p-dropdown id="probes" [options]="probes" [(ngModel)]="selectedProbe" placeholder="Select a probe" (onChange)="probeChanged(selectedProbe)"></p-dropdown>
        </div>
        <div class="col-12 p-1">
            <p-chart type="line" [data]="chartData" [options]="options"></p-chart>
        </div>
        <div class="col-12 p-1">
            <p-button label="Close" styleClass="p-button-secondary" class="flex justify-content-center" (onClick)="graphModal = false"></p-button>
        </div>
    </div>
</p-dialog>

<p-dialog [header]="'Retest ' + selectedPlate?.barcodeText"  [(visible)]="retestModal" [breakpoints]="{ '960px': '95vw' }" [style]="{ width: '90vw', height: '70vh' }" [draggable]="false" [resizable]="false">
    <div class="grid p-fluid flex flex-wrap">
        <div class="col-12">
            <label for="retestType">Type</label>
            <p-dropdown id="retestType" [options]="retestTypes" [(ngModel)]="selectedRetestType"placeholder="Select a retest type"></p-dropdown>
        </div>
        <div class="col-12">
            <label for="retestReason">Retest Reason</label>
            <p-dropdown id="retestReason" [options]="retestReasons" [(ngModel)]="selectedRetestReason" optionLabel="description" placeholder="Select a retest reason"></p-dropdown>
        </div>
        <div class="col-6 p-1">
            <p-button label="Close" styleClass="p-button-secondary" class="flex justify-content-center" (onClick)="retestModal = false"></p-button>
        </div>
        <div class="col-6 p-1">
            <p-button label="Submit" [loading]="submitWait" styleClass="p-button-success" class="flex justify-content-center" (onClick)="submitRetest()"></p-button>
        </div>
    </div>
</p-dialog>

<p-dialog header="Log in to Lims" [(visible)]="limsLoginModal" [breakpoints]="{ '960px': '95vw' }" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <div class="grid" (keydown.enter)="loginModalSubmit()">
        <div class="col-12 flex align-items-center justify-content-center">
            <div class="p-fluid">
                <div class="field">
                    <label for="username">Username</label>
                    <input pInputText [(ngModel)]="username" id="username" type="text" />
                </div>
                <div class="field">
                    <label for="password">Password</label>
                    <input pInputText [(ngModel)]="password" id="password" type="password" />
                </div>
                <p-button label="Login" [loading]="submitWait" (onClick)="loginModalSubmit()"></p-button>
            </div>
        </div>
    </div>
</p-dialog>